/* tslint:disable */
/* eslint-disable */
/**
 * FreightSimple Hubble API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import type {
  OffsetDateTime,
  LocalDate,
} from "@freightsimple/time/branded-types";

import { mapValues } from "../runtime";
import type { EdiOutboundTrackingReason } from "./EdiOutboundTrackingReason";
import {
  EdiOutboundTrackingReasonFromJSON,
  EdiOutboundTrackingReasonFromJSONTyped,
  EdiOutboundTrackingReasonToJSON,
  EdiOutboundTrackingReasonToJSONTyped,
} from "./EdiOutboundTrackingReason";
import type { EdiOutboundTrackingState } from "./EdiOutboundTrackingState";
import {
  EdiOutboundTrackingStateFromJSON,
  EdiOutboundTrackingStateFromJSONTyped,
  EdiOutboundTrackingStateToJSON,
  EdiOutboundTrackingStateToJSONTyped,
} from "./EdiOutboundTrackingState";

/**
 *
 * @export
 * @interface EdiOutboundTrackingResponse
 */
export interface EdiOutboundTrackingResponse {
  /**
   *
   * @type {string}
   * @memberof EdiOutboundTrackingResponse
   */
  ediOutboundTrackingId: string;
  /**
   *
   * @type {string}
   * @memberof EdiOutboundTrackingResponse
   */
  shipmentId: string;
  /**
   *
   * @type {string}
   * @memberof EdiOutboundTrackingResponse
   */
  proNumber?: string | null;
  /**
   *
   * @type {EdiOutboundTrackingReason}
   * @memberof EdiOutboundTrackingResponse
   */
  reason: EdiOutboundTrackingReason;
  /**
   *
   * @type {LocalDate}
   * @memberof EdiOutboundTrackingResponse
   */
  expectedDelivery?: LocalDate | null;
  /**
   *
   * @type {EdiOutboundTrackingState}
   * @memberof EdiOutboundTrackingResponse
   */
  state: EdiOutboundTrackingState;
  /**
   *
   * @type {number}
   * @memberof EdiOutboundTrackingResponse
   */
  attempts: number;
  /**
   *
   * @type {string}
   * @memberof EdiOutboundTrackingResponse
   */
  filename?: string | null;
  /**
   *
   * @type {number}
   * @memberof EdiOutboundTrackingResponse
   */
  sentEventCount?: number | null;
  /**
   *
   * @type {OffsetDateTime}
   * @memberof EdiOutboundTrackingResponse
   */
  sentAt?: OffsetDateTime | null;
  /**
   *
   * @type {string}
   * @memberof EdiOutboundTrackingResponse
   */
  lastError?: string | null;
  /**
   *
   * @type {OffsetDateTime}
   * @memberof EdiOutboundTrackingResponse
   */
  createdAt: OffsetDateTime;
}

/**
 * Check if a given object implements the EdiOutboundTrackingResponse interface.
 */
export function instanceOfEdiOutboundTrackingResponse(
  value: object,
): value is EdiOutboundTrackingResponse {
  if (
    !("ediOutboundTrackingId" in value) ||
    value["ediOutboundTrackingId"] === undefined
  )
    return false;
  if (!("shipmentId" in value) || value["shipmentId"] === undefined)
    return false;
  if (!("reason" in value) || value["reason"] === undefined) return false;
  if (!("state" in value) || value["state"] === undefined) return false;
  if (!("attempts" in value) || value["attempts"] === undefined) return false;
  if (!("createdAt" in value) || value["createdAt"] === undefined) return false;
  return true;
}

export function EdiOutboundTrackingResponseFromJSON(
  json: any,
): EdiOutboundTrackingResponse {
  return EdiOutboundTrackingResponseFromJSONTyped(json, false);
}

export function EdiOutboundTrackingResponseFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): EdiOutboundTrackingResponse {
  if (json == null) {
    return json;
  }
  return {
    ediOutboundTrackingId: json["ediOutboundTrackingId"],
    shipmentId: json["shipmentId"],
    proNumber: json["proNumber"] == null ? undefined : json["proNumber"],
    reason: EdiOutboundTrackingReasonFromJSON(json["reason"]),
    expectedDelivery:
      json["expectedDelivery"] == null ? undefined : json["expectedDelivery"],
    state: EdiOutboundTrackingStateFromJSON(json["state"]),
    attempts: json["attempts"],
    filename: json["filename"] == null ? undefined : json["filename"],
    sentEventCount:
      json["sentEventCount"] == null ? undefined : json["sentEventCount"],
    sentAt: json["sentAt"] == null ? undefined : json["sentAt"],
    lastError: json["lastError"] == null ? undefined : json["lastError"],
    createdAt: json["createdAt"],
  };
}

export function EdiOutboundTrackingResponseToJSON(
  json: any,
): EdiOutboundTrackingResponse {
  return EdiOutboundTrackingResponseToJSONTyped(json, false);
}

export function EdiOutboundTrackingResponseToJSONTyped(
  value?: EdiOutboundTrackingResponse | null,
  ignoreDiscriminator: boolean = false,
): any {
  if (value == null) {
    return value;
  }

  return {
    ediOutboundTrackingId: value["ediOutboundTrackingId"],
    shipmentId: value["shipmentId"],
    proNumber: value["proNumber"],
    reason: EdiOutboundTrackingReasonToJSON(value["reason"]),
    expectedDelivery: value["expectedDelivery"],
    state: EdiOutboundTrackingStateToJSON(value["state"]),
    attempts: value["attempts"],
    filename: value["filename"],
    sentEventCount: value["sentEventCount"],
    sentAt: value["sentAt"],
    lastError: value["lastError"],
    createdAt: value["createdAt"],
  };
}
